/**
 * ResposiveAutocomplete
 * 
 * @Author: Focci
 * @Date: 2023-09-29 19:28:46
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-29 19:28:46
 */

import PropTypes from 'prop-types'
import SVGEdit from '@img/edit.svg'
import { isFunction } from 'lodash-es'
import { useTranslations } from 'next-intl'
import InputBase from '@mui/material/InputBase'
// import SearchSuggestion from '@page/common/filter/combine/suggestion'
import CombineAutocomplete from '../CombineAutocomplete'
import './autocomplete.css'

function PopperComponent(props) {
  // eslint-disable-next-line no-unused-vars
  const { disablePortal, anchorEl, open, ...other } = props
  return (
    <div {...other} />
  )
}

export default function ResposiveAutocomplete({
  inputTopsideChild,
  inputUndersideChild,
  ...autocompleteProps
}) {
  const ts = useTranslations('search')
  const { onKeyDown } = autocompleteProps
  
  return (
    <div className="combine-autocomplete-custom">
      <CombineAutocomplete
        PopperComponent={PopperComponent}
        renderTags={() => null}
        size="large"
        renderInput={(params) => (
          <>
            {inputTopsideChild}
            <div className="flex items-center pl-3">
              <SVGEdit />
              <InputBase
                ref={params.InputProps.ref}
                inputProps={{
                  ...params.inputProps,
                  ...(isFunction(onKeyDown) ? { onKeyDown } : null)
                }}
                sx={{ width: '100%', fontSize: '.7rem', px: '.75rem', py: '.6rem' }}
                autoFocus
                placeholder={ts('searchInputPlaceholder')}
              />
            </div>
            {inputUndersideChild}
          </>
        )}
        {...autocompleteProps}
      />
    </div>
  )
}

ResposiveAutocomplete.propTypes = {
  inputUndersideChild: PropTypes.node,
}
